import { render, staticRenderFns } from "./LotsTable.vue?vue&type=template&id=375950e0&scoped=true"
import script from "./LotsTable.vue?vue&type=script&lang=ts"
export * from "./LotsTable.vue?vue&type=script&lang=ts"
import style0 from "./LotsTable.vue?vue&type=style&index=0&id=375950e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375950e0",
  null
  
)

export default component.exports